// extracted by mini-css-extract-plugin
module.exports = {"title":"ShareReportPreview_title__2uLGe","date":"ShareReportPreview_date__25vo6","description":"ShareReportPreview_description__2kk8a","hr":"ShareReportPreview_hr__2HpIN"};